/** The common return to rest for Learn cards and the inert profile card. */
export const LEARN_DECK_RECOVERY_SPRING = {
  damping: 22,
  mass: 0.8,
  overshootClamping: true,
  stiffness: 260,
};
